package ir.hosen.resume.components

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px

val FooterIconStyle = CssStyle {
    base {
        Modifier.size(28.px)
    }
    hover {
        Modifier.size(32.px)
    }
}